/**
*
* All strings used in the app should be stored here.
*
*/
export default {
  title: "Hipster's Future",
  openingBlurb: "Input a scan of the patient's hip socket with an implant and set the angles to ensure a proper fit.",
  imageButton: "Input Image",
  discardButton: "Discard",
  continueButton: "Continue",
  addFirstTeardropPrompt: "Tap on the image to add the first teardrop",
  addSecondTeardropPrompt: "Tap on the image to add the final teardrop",
  noAnglePrompt: "Enter an inklination angle to see the inklination line",
  dragPrompt: "Drag the teardrops and inklination lines for a proper fit",
  inklinationAngleLabel: "Inklination Angle",
  replaceImageButton: "Replace Image",
  invertButton: "Invert",
  zoomInButton: "+",
  zoomOutButton: "-"
}



// WEBPACK FOOTER //
// ./src/strings.js